module.exports = __webpack_public_path__ + "media/images/home/howto_title_bg-bcbc20559efb675e3895fb51054ba16d.png";